import loggingService from '../services/util/loggingService'

var serviceName = 'organizationContactService'
var path = '/OrganizationContact/'
var isDebug = false

function listLookup (http, organizationId) {
    loggingService.log(isDebug, serviceName, 'ListLookup - organizationId:' + organizationId)

    return http.get(path + 'ListLookup/' + organizationId)
}

export default {
    listLookup: listLookup
}



// WEBPACK FOOTER //
// ./src/services/organizationContactService.js